// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import CreateAlertConditionSelectorTemplate from '@front/templates/CreateAlertConditionSelectorTemplate.html';
import { ContainerControl } from '../../elements/ContainerControl';
import { Resources } from '@shared/localizations/Resources';
import { AlertCondition, getAlertConditionKey } from '@shared/utils/Alert/AlertConstants';
import { ResourcesManager } from '@shared/commons/properties/ResourcesManager';
import { createContextMenuItemsFromEnum } from '@shared/utils/ContextMenuUtils';
export class CreateAlertConditionSelector extends ContainerControl {
    constructor() {
        super();
    }
    getType() {
        return 'CreateAlertConditionSelector';
    }
    oninit() {
        super.oninit();
        this.repopulate();
        this.observe('selectedItem', this.updateAlertCondition);
        this.observe('value', this.updateAlertConditionValue);
        ResourcesManager.onLocaleChange.Subscribe(this.localize, this);
        this.localize();
    }
    updateAlertCondition(selectedItem) {
        if (!isNullOrUndefined(selectedItem)) {
            void this.set({ value: selectedItem.value });
        }
    }
    updateAlertConditionValue(newV, oldV) {
        const items = this.get('items');
        if (!isValidArray(items)) {
            return;
        }
        for (let i = 0; i < items.length; i++) {
            if (items[i].value === newV) {
                void this.set({ selectedItem: items[i] });
                break;
            }
        }
    }
    dispose() {
        ResourcesManager.onLocaleChange.UnSubscribe(this.localize, this);
        super.dispose();
    }
    repopulate() {
        const items = this.get('items');
        void this.set({ selectedItem: items[0] });
    }
    localize() {
        void this.set('label', Resources.getResource('screen.Alerts.Label.Condition'));
    }
}
ContainerControl.extendWith(CreateAlertConditionSelector, {
    template: CreateAlertConditionSelectorTemplate,
    data: function () {
        return {
            label: '',
            instrument: null,
            items: createContextMenuItemsFromEnum(AlertCondition, getAlertConditionKey),
            selectedItem: null,
            value: -1,
            width: 198
        };
    }
});
